var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pad30" },
    [
      _vm.goodsAddVisible
        ? _c("goodsDrawer", {
            attrs: {
              goodsNum: _vm.goodsNum,
              show: _vm.goodsAddVisible,
              selections: _vm.selections,
              categoryList: _vm.categoryList,
              disChooseList: _vm.disChooseList,
              disableSKUSelection: _vm.disableSKUSelection
            },
            on: {
              "update:goodsNum": function($event) {
                _vm.goodsNum = $event
              },
              "update:goods-num": function($event) {
                _vm.goodsNum = $event
              },
              "update:show": function($event) {
                _vm.goodsAddVisible = $event
              },
              "update:selections": function($event) {
                _vm.selections = $event
              },
              "update:categoryList": function($event) {
                _vm.categoryList = $event
              },
              "update:category-list": function($event) {
                _vm.categoryList = $event
              },
              "update:disChooseList": function($event) {
                _vm.disChooseList = $event
              },
              "update:dis-choose-list": function($event) {
                _vm.disChooseList = $event
              },
              "update:disableSKUSelection": function($event) {
                _vm.disableSKUSelection = $event
              },
              "update:disable-s-k-u-selection": function($event) {
                _vm.disableSKUSelection = $event
              }
            }
          })
        : _vm._e(),
      _vm._m(0),
      _c(
        "div",
        { staticClass: "flex" },
        [
          _c(
            "Card",
            { staticClass: "flex-auto" },
            [
              _c("template", { slot: "header" }, [
                _c(
                  "div",
                  { staticClass: "header flex items-center justify-between" },
                  [
                    _c("div", { staticClass: "pointer title" }, [
                      _vm._v("移出SKU")
                    ]),
                    _c(
                      "el-button",
                      {
                        staticClass: "mar10-tb",
                        attrs: { type: "primary" },
                        on: { click: _vm.goodOut }
                      },
                      [_vm._v("选择")]
                    )
                  ],
                  1
                )
              ]),
              _c(
                "div",
                { staticClass: "pad20" },
                [
                  !_vm.goodOutList.length
                    ? _c("div", { staticClass: "mar10-b" }, [
                        _vm._v("请选择需要移除的商品SKU")
                      ])
                    : _vm._e(),
                  _c(
                    "el-table",
                    {
                      ref: "multipleTable",
                      attrs: {
                        "max-height": "500",
                        "row-key": "id",
                        data: _vm.goodOutList
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "name",
                          "show-overflow-tooltip": "",
                          label: "商品名称"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: { fixed: "right", label: "操作", width: "100" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                !scope.row.children || !scope.row.specType
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: "primary"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.delGood(scope.row.id)
                                          }
                                        }
                                      },
                                      [_vm._v("移除")]
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            2
          ),
          _c(
            "Card",
            { staticClass: "mar20-l flex-auto" },
            [
              _c("template", { slot: "header" }, [
                _c(
                  "div",
                  { staticClass: "header flex items-center justify-between" },
                  [
                    _c("div", { staticClass: "pointer title" }, [
                      _vm._v("移入商品")
                    ]),
                    _c(
                      "div",
                      { staticClass: "mar5-tb" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.addSpu }
                          },
                          [_vm._v("新增SPU")]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "mar10-l",
                            attrs: { type: "primary" },
                            on: { click: _vm.goodIn }
                          },
                          [_vm._v("选择")]
                        )
                      ],
                      1
                    )
                  ]
                )
              ]),
              _c(
                "div",
                { staticClass: "pad20" },
                [
                  !_vm.goodInList.length
                    ? _c("div", { staticClass: "mar10-b" }, [
                        _vm._v("请选择目标商品")
                      ])
                    : _vm._e(),
                  _c(
                    "el-table",
                    { ref: "multipleTable", attrs: { data: _vm.goodInList } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "name",
                          "show-overflow-tooltip": "",
                          label: "商品名称"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            2
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "mar20-t text-right" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.goodShift } },
            [_vm._v("确定调整")]
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "新增SPU",
            visible: _vm.addSpuVisible,
            width: "550px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.addSpuVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "addSpuForm",
                  staticClass: "demo-ruleForm",
                  attrs: {
                    model: _vm.addSpuForm,
                    rules: _vm.rules,
                    "label-width": "100px"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品类目：", prop: "categoryIdList" } },
                    [
                      _c("el-cascader", {
                        staticClass: "w240",
                        attrs: {
                          options: _vm.categoryList,
                          clearable: "",
                          props: _vm.categoryProps
                        },
                        on: { change: _vm.categoryChange },
                        model: {
                          value: _vm.addSpuForm.categoryIdList,
                          callback: function($$v) {
                            _vm.$set(_vm.addSpuForm, "categoryIdList", $$v)
                          },
                          expression: "addSpuForm.categoryIdList"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品名称：", prop: "name" } },
                    [
                      _c("el-input", {
                        staticClass: "w240",
                        model: {
                          value: _vm.addSpuForm.name,
                          callback: function($$v) {
                            _vm.$set(_vm.addSpuForm, "name", $$v)
                          },
                          expression: "addSpuForm.name"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.submitForm("addSpuForm")
                            }
                          }
                        },
                        [_vm._v("确 定")]
                      ),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              return _vm.resetForm("addSpuForm")
                            }
                          }
                        },
                        [_vm._v("取 消")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "f14 flex radius5 pad10 tips mar15-b" }, [
      _c("i", { staticClass: "el-icon-info blue mar10-r mar5-t" }),
      _c("div", { staticClass: "flex-auto" }, [
        _c("div", { staticClass: "f15 mar5-b" }, [_vm._v("操作须知")]),
        _c("div", { staticClass: "gray6" }, [
          _vm._v(
            "\n        本功能属于高阶操作，适用于商品sku调整SPU归属（仅支持单规格商品及单规格项的多规格商品），请在农信商城运营老师培训、指导下进行使用，以免数据偏差\n      "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }